
class WorkflowCancellationError extends Error {
    constructor(message) {
        super(message);
        this.name = "WorkflowCancellationError";
    }
}

export default WorkflowCancellationError;


//////////////////
// WEBPACK FOOTER
// ./src/models/errors/WorkflowCancellationError.js
// module id = AbLw
// module chunks = 1